import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {
  transform(value: any, decimalCount?: any): any {
    let originalVal = value;
    if (value !== undefined && /^[-+]?\d+\.?\d*$/.test(value)) {
      let roundOffVal;
      if (decimalCount === undefined) {
        roundOffVal = (Math.round(value * 100) / 100).toFixed(2);
      } else {
        let factor = Math.pow(10, decimalCount);
        roundOffVal = Math.round(value * factor) / factor;
        roundOffVal = this.toFixedNumber(roundOffVal, decimalCount);
      }
      let parts = roundOffVal.toString().split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?=$))/g, ',') + (parts[1] ? '.' + parts[1] : '');
    } else if (!value || value === 'Infinity' || value === '-Infinity' || value === 'null' || value === 'NaN') {
      originalVal = 'N/A';
    }
    return originalVal;
  }
  toFixedNumber(number, decimalCount) {
    const spitedValues = String(number.toLocaleString(undefined, { minimumFractionDigits: 5 })).split('.');
    let decimalValue = spitedValues.length > 1 ? spitedValues[1] : '';
    decimalValue = decimalValue.concat('00').substr(0, decimalCount);

    return spitedValues[0] + '.' + decimalValue;
  }
}
